3<template>
  <donut-chart08-template
    :board-ids="[242]"
    :data-type="dataType"
    field-code="facility-public"
    :graph-id="63"
    title="(다중(공중)이용시설) 비상조치계획수립 현황"
    unit="건"/>
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart63',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
